// extracted by mini-css-extract-plugin
export var billingAddress = "_qr-g";
export var contactInfo = "_qr-d";
export var customerInfoContainer = "_qr-c";
export var customerInfoContainerMobile = "_qr-h";
export var customerInfoRow = "_qr-a";
export var customerInfoSection = "_qr-b";
export var fullWidthDividerMobile = "_qr-i";
export var imageContainer = "_qr-1";
export var paymentMethod = "_qr-e";
export var priceText = "_qr-6";
export var priceTextMobile = "_qr-7";
export var product = "_qr-0";
export var productImage = "_qr-2";
export var productInfo = "_qr-4";
export var productMobile = "_qr-9";
export var productTitle = "_qr-8";
export var quantityBadge = "_qr-3";
export var quantityText = "_qr-5";
export var shippingAddress = "_qr-f";